import React, { useState, useMemo, useContext, useEffect } from 'react';
import { IoIosArrowRoundBack } from 'react-icons/io';

const BackButton = (props) => {
    return (
        <div className={props.classes ? props.classes + " back-btn" : "back-btn"} onClick={() => window.history.back()} ><IoIosArrowRoundBack/> GO BACK</div>
    )
}

export default BackButton;